import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { getDate } from "utils/formatDate";
import configs from "constants/configs";
import { Cookies } from "react-cookie";
import danhSachThongTinVayApi from "../../service/ChoThongTin/danhSachThongTinVayApi";
import moment from "moment";
import thongBaoThongTinVayApi from "service/ChoThongTin/thongBaoThongTinVayApi";
import thongBaoApi from "service/thongBaoApi";
import { ModalThongBaoKhiDangNhap } from "components/ThongBaoKhiDangNhap";
import { ModalThongBaoDangKyVayMoi } from "components/ThongBaoDangKyVayMoi";
import { ModalThongbaoHanSuDung } from "components/ThongBaoKhiDangNhap/ThongBaoHanSuDung";
import { ModalThongBaoApp } from "components/ThongBaoApp";
import userApi from "../../service/userApi";
// import { useCacheBuster } from 'react-cache-buster';

const Header = (props) => {
  const cookies = new Cookies();
  let { list, onChange, thongTin, userInfo, thongBao } = props;
  let { Name, ExpiredDate } = thongTin ? thongTin : {};
  let { Image, FullName, UserName } = userInfo ? userInfo : {};
  let { List, Total } = thongBao ? thongBao : {};

  const [isShowModelThongBao, setModelThongBao] = useState(false);
  const [isRoleChoTinDung, setRoleChoTinDung] = useState(false);
  const [isDangKyChoTinDung, setDangKyChoTinDung] = useState(false);
  const [listDanhSSach, setListDanhSach] = useState([]);
  const [iCountDataNew, setCountDataNew] = useState(0);
  const [logoURL, setLogo] = useState("");
  const [valueHanSuDung, setValueHanSuDung] = useState(-1);
  const [showThongBaoHanSuDung, SetShowThongBaoHanSuDung] = useState(false);
  const hideThongBaoHanSuDung = () => {
    if (showThongBaoHanSuDung == true) {
      cookies.set("isShowThongBaoHanDung", "0", { path: "/" });
      SetShowThongBaoHanSuDung(false);
    }
  };
  //const { checkCacheStatus } = useCacheBuster();
  const toggleModal = () => {
    setModelThongBao(false);
  };
  const toggleModalData = () => {
    setCountDataNew(0);
  };
  const callApiDataNew = () => {
    const interval = setInterval(() => {
      var date = moment().add(-60, "seconds").format("MM/DD/YYYY HH:mm:ss");
      thongBaoThongTinVayApi
        .getSoLuongDataMoi(userInfo.CompanyID, date)
        .then((responseDetail) => {
          if (responseDetail.status === 200) {
            setCountDataNew(responseDetail.data);
          }
        });
    }, 60000);
    return () => clearInterval(interval);
  };
  let urlChoTinDung = window.urlChoTinDung + "cho-thong-tin/danh-sach-vay.aspx";
  let urlDangKyCho =
    window.urlChoTinDung + "cho-thong-tin/Dang-Ky-Tai-Khoan.aspx";
  let urlError = "/trang-chu/Page-Error.aspx";
  const init = {
    iTotal: 0,
    List: [],
  };
  useEffect(() => {
    // Set cookie theo subdomain  hết hạn, để sử dụng cookie này ở domain .morman.vn
    // const domain = window.location.hostname;
    // document.cookie = `userInfo=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 UTC`;

    getLogo();
    var isShowThongBaoHanDung = cookies.get("isShowThongBaoHanDung");
    var expiredate = cookies.get("expiredatecom");
    setValueHanSuDung(expiredate);
    if (isShowThongBaoHanDung != "0") {
      if (expiredate && expiredate <= 5 && expiredate > -1) {
        SetShowThongBaoHanSuDung(true);
      }
    }

    //checkCacheStatus();
    if (typeof userInfo.CompanyID !== "undefined") {
      var popMsg = cookies.get("isShowThongBaoChoTD");
      if (typeof popMsg === "undefined" || popMsg != "1") {
        thongBaoThongTinVayApi
          .checkQuyenHienThi(userInfo.CompanyID)
          .then((responseDetail) => {
            if (responseDetail.data == "1") {
              setDangKyChoTinDung(true);
              setModelThongBao(false);
              cookies.set("isShowThongBaoChoTD", "0", { path: "/" });
            } else if (responseDetail.data == "0") {
              setModelThongBao(true);
              cookies.set("isShowThongBaoChoTD", "1", { path: "/" });
            }
          });
      } else {
        thongBaoThongTinVayApi
          .checkQuyenHienThi(userInfo.CompanyID)
          .then((responseDetail) => {
            if (responseDetail.data == "1") {
              setDangKyChoTinDung(true);
            }
          });
      }
      danhSachThongTinVayApi.checkRoleChoTinDung().then((res) => {
        if (
          typeof res.data.IsRoleChoTinDung === "undefined" ||
          res.data.IsRoleChoTinDung == true
        ) {
          setRoleChoTinDung(true);
          let userMorman =
            userInfo.CompanyID +
            "&" +
            userInfo.CompanyName +
            "&" +
            userInfo.NameDaiDien +
            "&" +
            userInfo.Administrator;
          const token = cookies.get("userInfo").replace(/"/g, "");
          cookies.set("tokenMorman", token, {
            domain: ".morman.vn",
            path: "/",
          });
          cookies.set("userMorman", userMorman, {
            domain: ".morman.vn",
            path: "/",
          });
        } else {
          cookies.set("tokenMorman", "", { domain: ".morman.vn", path: "/" });
          cookies.set("userMorman", "", { domain: ".morman.vn", path: "/" });
        }
      });

      /// lấy count hiển thị ở chuông thông báo, và danh sách khi click vào
      const dataSearch = {
        IdCuaHang: userInfo.CompanyID,
        sHoVaTen: "",
        iPageIndex: 1,
        LoaiDangKy: "",
        iPageSize: 20,
      };
      thongBaoThongTinVayApi.danhSachDangKyVay(dataSearch).then((response) => {
        if (response != null && response.data != null) {
          setListDanhSach({
            ...listDanhSSach,
            iTotal: response.data.iTotal,
            List: response.data.List,
          });
          callApiDataNew();
        }
      });
    } else {
      cookies.set("tokenMorman", "", { domain: ".morman.vn", path: "/" });
      cookies.set("userMorman", "", { domain: ".morman.vn", path: "/" });
    }
    CheckSuDung();
    CheckHanSuDung();
    ThongBaoDuyetIp();
  }, [userInfo.CompanyID]);

  const [isThongBaoApp, setIsThongBaoApp] = useState(false);
  const [nameThongBaoApp, setNameThongBaoApp] = useState("");

  const CheckSuDung = () => {
    setIsThongBaoApp(false);
    setNameThongBaoApp("");

    var noshowapp = cookies.get("noshowapp");
    if (noshowapp === "" || noshowapp === undefined || noshowapp === null) {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        setIsThongBaoApp(true);
        setNameThongBaoApp("Android");
      }
      if (/android/i.test(userAgent)) {
        setIsThongBaoApp(true);
        setNameThongBaoApp("Android");
      }
      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        setIsThongBaoApp(true);
        setNameThongBaoApp("iOS");
      }
    }
  };

  const CheckHanSuDung = () => {
    if (UserName != undefined) {
      userApi.checkhansudung(UserName).then((response) => {
        if (
          response.data.IsHetHan != null &&
          response.data.IsHetHan != undefined
        ) {
          if (response.data.IsHetHan == true) {
            console.log("Logout");
            cookies.set("tokenMorman", "", { domain: ".morman.vn", path: "/" });
            cookies.set("userMorman", "", { domain: ".morman.vn", path: "/" });
            window.location.href = configs.mormanServer + "dang-nhap.aspx";
          }
          if (response.data.Logout == true) {
            cookies.set("tokenMorman", "", { domain: ".morman.vn", path: "/" });
            cookies.set("userMorman", "", { domain: ".morman.vn", path: "/" });
            window.location.href = configs.mormanServer + "dang-nhap.aspx";
          }
        }
      });
    }
  };

  const [IsSuDungIpBaoMat, SetIsSuDungIpBaoMat] = useState(false);
  const [TongXacThuc, SetTongXacThuc] = useState(0);
  const [DanhSachThongBao, SetDanhSachThongBao] = useState([]);
  const ThongBaoDuyetIp = () => {
    thongBaoApi.listThongBaoIp().then((response) => {
      if (response.data && response.data.IsSuDungIpBaoMat != undefined) {
        let isBaoMat = response.data.IsSuDungIpBaoMat;
        if (isBaoMat === true) {
          SetTongXacThuc(response.data.TongXacThuc);
          SetDanhSachThongBao(response.data.DanhSachThongBao);
        }
        SetIsSuDungIpBaoMat(isBaoMat);
      }
    });
  };

  const LuuDiaChiIp = (code) => {
    thongBaoApi.LuuDiaChiIP(code).then((response) => {
      if (response.data) {
        ThongBaoDuyetIp();
      }
    });
  };

  const getLogo = () => {
    userApi.getLogoUrl().then((response) => {
      setLogo(response.data);
    });
  };

  const XoaThongBaoDuyetIp = (id) => {
    thongBaoApi.XoaThongBaoDuyetIP(id).then((response) => {
      if (response.data) {
        ThongBaoDuyetIp();
      }
    });
  };
  const LogOut = () => {
    cookies.set("getCurrentUser", "", { path: "/" });
    localStorage.setItem("getMenu", "0");
    cookies.set("isDungChinhThuc", "0", { domain: ".morman.vn", path: "/" });
    cookies.set("tokenMorman", "", { domain: ".morman.vn", path: "/" });
    cookies.set("userMorman", "", { domain: ".morman.vn", path: "/" });
    cookies.set("isShowThongBaoHanDung", "1", { path: "/" });
    localStorage.removeItem("check_ThongBao");
    window.location.href = configs.mormanServer + "dang-nhap.aspx?Logout=1";
  };

  return (
    <nav className="header-navbar navbar-expand-md navbar navbar-with-menu navbar-without-dd-arrow fixed-top navbar-light  navbar-brand-center page-color1">
      <div className="navbar-wrapper">
        <div className="navbar-header">
          <ul className="nav navbar-nav flex-row">
            <li className="nav-item mobile-menu d-md-none mr-auto">
              <a
                className="nav-link nav-menu-main menu-toggle hidden-xs"
                href={window.mormanServer + "trang-chu.aspx"}
              >
                <i className="ft-menu font-large-1"></i>
              </a>
            </li>

            <li className="nav-item d-md-none">
              <a
                className="navbar-brand"
                href={window.mormanServer + "trang-chu.aspx"}
              >
                <h3 className="brand-text store">{Name}</h3>
              </a>
            </li>

            <li className="nav-item d-md-none">
              <a
                href={window.mormanServer + "trang-chu.aspx"}
                className="nav-link open-navbar-container"
                data-toggle="collapse"
                data-target="#navbar-mobile"
              >
                <i className="la la-ellipsis-v"></i>
              </a>
            </li>
          </ul>
        </div>

        <div className="navbar-container content logo-small">
          <div className="collapse navbar-collapse" id="navbar-mobile">
            <ul className="nav navbar-nav mr-auto float-left ">
              <li className="nav-item d-none d-md-block ">
                <a
                  className="nav-link nav-menu-main menu-toggle hidden-xs navi-menu"
                  href={window.mormanServer + "trang-chu.aspx"}
                >
                  <i className="ft-menu"></i>
                </a>
              </li>

              <li className="nav-item logo-sm d-none d-md-block menu-l">
                <a className="" href={window.mormanServer + "trang-chu.aspx"}>
                  <img
                    className="brand-logo"
                    alt="modern admin logo"
                    src={logoURL}
                  />
                </a>{" "}
              </li>
              <li className="dropdown nav-item mega-dropdown width-dropdown home-newcv">
                <div className="content-header-right2">
                  <a
                    className="dropdown-toggle nav-link store store-mb"
                    href={"/"}
                    data-toggle="dropdown"
                  >
                    <span>{Name}</span> <i className="la la-angle-down"></i>
                  </a>
                  {list && (
                    <ul className="mega-dropdown-menu dropdown-menu row">
                      {list.map((item, index) => (
                        <li
                          className="col-md-4 sotre-list"
                          key={"cuaHang" + index}
                        >
                          {item.isHanDung == false && (
                            <>
                              <a
                                // style={{ cursor: "no-drop" }}
                                onClick={onChange(item.Code)}
                              >
                                <h6 className="dropdown-menu-header text-uppercase mb-1">
                                  {item.Name}
                                  <i
                                    style={{
                                      color: "#bd0a0a",
                                      fontSize: "12px",
                                      opacity: "0.7",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    (Hết hạn)
                                  </i>
                                </h6>
                                <div className="mega-menu-carousel-example">
                                  <div>
                                    <i className="la la-institution"></i>{" "}
                                    {item.Address}
                                  </div>
                                </div>
                                <div className="mega-menu-carousel-example">
                                  <div>
                                    {" "}
                                    <i className="la la-phone-square"></i>{" "}
                                    {item.Phone}
                                  </div>
                                </div>
                              </a>
                            </>
                          )}
                          {item.Status === 2 && (
                            <>
                              <a
                                style={{ cursor: "no-drop" }}
                                //onClick={onChange(item.Code)}
                              >
                                <h6 className="dropdown-menu-header text-uppercase mb-1">
                                  {item.Name}
                                  <i
                                    style={{
                                      color: "#bd0a0a",
                                      fontSize: "12px",
                                      opacity: "0.7",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    (Đang khóa)
                                  </i>
                                </h6>
                                <div className="mega-menu-carousel-example">
                                  <div>
                                    <i className="la la-institution"></i>{" "}
                                    {item.Address}
                                  </div>
                                </div>
                                <div className="mega-menu-carousel-example">
                                  <div>
                                    {" "}
                                    <i className="la la-phone-square"></i>{" "}
                                    {item.Phone}
                                  </div>
                                </div>
                              </a>
                            </>
                          )}
                          {item.Status !== 2 && item.isHanDung == true && (
                            <>
                              <a onClick={onChange(item.Code)}>
                                <h6 className="dropdown-menu-header text-uppercase mb-1">
                                  {item.Name}
                                </h6>
                                <div className="mega-menu-carousel-example">
                                  <div>
                                    <i className="la la-institution"></i>{" "}
                                    {item.Address}
                                  </div>
                                </div>
                                <div className="mega-menu-carousel-example">
                                  <div>
                                    {" "}
                                    <i className="la la-phone-square"></i>{" "}
                                    {item.Phone}
                                  </div>
                                </div>
                              </a>
                            </>
                          )}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </li>

              <li className="nav-item hotline-home ">
                <a
                  className=""
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    paddingTop: "5px",
                  }}
                  href="callto://+0903285356"
                >
                  <img
                    className="hidden-mobile-main brand-logo"
                    alt=""
                    src="/app-assets/images/call24.png"
                  />
                  <img
                    className="d-md-none  brand-logo"
                    src="/app-assets/images/call24-mobile.png"
                    alt=""
                  />
                  <h3 className="brand-text">090 328 5356</h3>
                </a>
              </li>

              <li className="nav-item hotline-home">
                <a
                  className=""
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    paddingTop: "5px",
                  }}
                  href="callto://+0981528850"
                >
                  <img
                    className="hidden-mobile-main brand-logo"
                    alt=""
                    src="/app-assets/images/info.png"
                  />
                  <img
                    className="d-md-none  brand-logo"
                    src="/app-assets/images/info-mobile.png"
                    alt=""
                  />
                  <h3 className="brand-text">0981 528 850</h3>
                </a>
              </li>
            </ul>
            <ul
              className="nav navbar-nav float-right"
              style={{ position: "relative" }}
            >
              {valueHanSuDung < 15 && (
                <li className="dropdown dropdown-notification nav-item notiVay">
                  <a
                    className="nav-link nav-link-label"
                    href="http://timnoxau.morman.vn/"
                    target="_blank"
                    rel="noreferrer"
                    style={{ marginRight: -30 }}
                  >
                    <span
                      className="badge badge-pill badge-default badge-danger badge-default badge-up badge-glow"
                      style={{
                        top: 7,
                        color: "red",
                        marginRight: 10,
                        fontSize: 18,
                      }}
                    >
                      HẠN SỬ DỤNG CÒN LẠI {valueHanSuDung} NGÀY
                    </span>
                  </a>
                </li>
              )}
              <li className="dropdown dropdown-notification nav-item notiVay">
                <a
                  className="nav-link nav-link-label"
                  href={() => false}
                  data-toggle="dropdown"
                >
                  {/* <i className="fas fa-bell"></i> */}
                  <i class="fas fa-user-tag"></i>
                  <span
                    className="badge badge-pill badge-default badge-danger badge-default badge-up badge-glow"
                    // style={{ right: "34px", top: "4px" }}
                  >
                    {listDanhSSach.iTotal}
                  </span>
                </a>
                <ul className="dropdown-menu dropdown-menu-media dropdown-menu-right">
                  <li class="scrollable-container media-list w-100 ps-container ps-theme-dark">
                    {listDanhSSach.List &&
                      listDanhSSach.List.slice(0, 4).map((item) => {
                        return (
                          <a href={isRoleChoTinDung ? urlChoTinDung : urlError}>
                            <div class="media">
                              <div class="media-left align-self-center">
                                <i class="la la-exclamation-circle"></i>
                              </div>
                              <div class="media-body">
                                <h6 class="media-heading blue darken-1">
                                  Khách hàng <strong>{item.HoVaTen}</strong> vừa
                                  đăng ký vay ở chợ thông tin tín dụng
                                </h6>
                                {/* <p class="notification-text font-small-3 text-muted">
                                  fsadf
                                </p> */}
                              </div>
                            </div>
                          </a>
                        );
                      })}

                    <div class="ps-scrollbar-x-rail">
                      <div class="ps-scrollbar-x" tabindex="0"></div>
                    </div>
                    <div class="ps-scrollbar-y-rail">
                      <div class="ps-scrollbar-y" tabindex="0"></div>
                    </div>
                  </li>
                </ul>
              </li>
              <li className="dropdown dropdown-notification nav-item">
                <a
                  className="nav-link nav-link-label"
                  href="http://timnoxau.morman.vn/"
                  target="_blank"
                  rel="noreferrer"
                  style={{ marginRight: 50 }}
                >
                  <span
                    className="badge badge-pill badge-default badge-danger badge-default badge-up badge-glow"
                    style={{ top: 10, color: "red", marginRight: 10 }}
                  >
                    Tìm nợ xấu
                  </span>
                </a>
              </li>
              <li className="dropdown dropdown-notification nav-item">
                {isRoleChoTinDung ? (
                  <a
                    className="nav-link nav-link-label"
                    href={isDangKyChoTinDung ? urlChoTinDung : urlDangKyCho}
                    target="_blank"
                    rel="noreferrer"
                    style={{ marginRight: 100 }}
                  >
                    <span
                      className="badge badge-pill badge-default badge-danger badge-default badge-up badge-glow"
                      style={{ top: 10, color: "red", marginRight: 40 }}
                    >
                      CHỢ TÍN DỤNG
                    </span>
                  </a>
                ) : (
                  <a
                    className="nav-link nav-link-label"
                    href={urlError}
                    target="_blank"
                    rel="noreferrer"
                    style={{ marginRight: 100 }}
                  >
                    <span
                      className="badge badge-pill badge-default badge-danger badge-default badge-up badge-glow"
                      style={{ top: 10, color: "red", marginRight: 40 }}
                    >
                      CHỢ TÍN DỤNG
                    </span>
                  </a>
                )}
              </li>

              <li className="dropdown dropdown-notification nav-item">
                <a
                  className="nav-link nav-link-label"
                  href="https://www.facebook.com/groups/Hotro.MorMan/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span
                    className="badge badge-pill badge-default badge-danger badge-default badge-up badge-glow"
                    style={{ top: 10 }}
                  >
                    Facebook
                  </span>
                </a>
              </li>
              <li className="dropdown dropdown-notification nav-item">
                <a
                  className="text-transfer-link"
                  href={"/"}
                  data-toggle="dropdown"
                >
                  HSD: {getDate(ExpiredDate)}
                </a>
                <ul className="dropdown-menu dropdown-menu-media dropdown-menu-right">
                  <li className="w-100">
                    <span className="text-transfer">
                      Chuyển tiền qua tài khoản ngân hàng:
                      <br />
                      <span className="text-transfer-color">
                        1. Ngân hàng thương mại cổ phần Quân đội – Military
                        Commercial Joint Stock Bank – (MB):
                      </span>
                      <br />
                      Số tài khoản: 0771100034006
                      <br />
                      Chủ tài khoản: Công ty cổ phần công nghệ và truyền thông
                      Niềm Tin
                      <br />
                      Chi nhánh: Đống Đa
                      <br />
                      <span className="text-transfer-color">
                        2. Ngân hàng TMCP Kỹ thương Việt Nam – Vietnam
                        Technology and Commercial Joint Stock Bank – (TCB):
                      </span>
                      <br />
                      Số tài khoản: 19135813652017
                      <br />
                      Chủ tài khoản: Trần Anh Trung
                      <br />
                      <span className="text-transfer-color">
                        Ghi chú khi chuyển khoản:
                      </span>
                      <br />
                      Tại mục “Nội Dung” khi chuyển khoản, bạn ghi rõ: TK:
                      Ten_Dang_Nhap (Thay "Ten_Dang_Nhap" bằng tài khỏan đăng
                      nhập của bạn)
                    </span>
                  </li>
                </ul>
              </li>

              <li className="dropdown dropdown-notification nav-item">
                <a
                  className="nav-link nav-link-label"
                  href={() => false}
                  data-toggle="dropdown"
                >
                  <i className="fas fa-bell"></i>
                  <span className="badge badge-pill badge-default badge-danger badge-default badge-up badge-glow">
                    {Total}
                  </span>
                </a>
                <ul className="dropdown-menu dropdown-menu-media dropdown-menu-right">
                  <li class="scrollable-container media-list w-100 ps-container ps-theme-dark">
                    {List &&
                      List.map((item) => {
                        let { NotificationID, Title, Description } = item;
                        return (
                          <a
                            href={
                              configs.mormanServer +
                              `/trang-chu/quan-tri-he-thong/thong-bao.aspx?id=${NotificationID}&time=${new Date().getTime()}`
                            }
                          >
                            <div class="media">
                              <div class="media-left align-self-center">
                                <i class="la la-exclamation-circle"></i>
                              </div>
                              <div class="media-body">
                                <h6 class="media-heading blue darken-1">
                                  <strong>{Title}</strong>
                                </h6>
                                <p class="notification-text font-small-3 text-muted">
                                  {Description}
                                </p>
                              </div>
                            </div>
                          </a>
                        );
                      })}

                    <div class="ps-scrollbar-x-rail">
                      <div class="ps-scrollbar-x" tabindex="0"></div>
                    </div>
                    <div class="ps-scrollbar-y-rail">
                      <div class="ps-scrollbar-y" tabindex="0"></div>
                    </div>
                  </li>
                </ul>
              </li>

              {IsSuDungIpBaoMat === true && (
                <>
                  <li className="dropdown dropdown-notification nav-item">
                    <a
                      className="nav-link nav-link-label"
                      href={() => false}
                      data-toggle="dropdown"
                    >
                      <i className="fas fa-user-shield"></i>
                      <span className="badge badge-pill badge-default badge-danger badge-default badge-up badge-glow">
                        {TongXacThuc}
                      </span>
                    </a>
                    <ul className="dropdown-menu dropdown-menu-media dropdown-menu-right">
                      <li class="scrollable-container media-list w-120 ps-container ps-theme-dark">
                        {DanhSachThongBao &&
                          DanhSachThongBao.map((item) => {
                            let { ID, UserName, Code, IP } = item;
                            return (
                              <div
                                className="media"
                                style={{ padding: "12px" }}
                              >
                                <div className="media-body">
                                  <table style={{ clear: "both" }}>
                                    <tr>
                                      <td>
                                        <p className="notification-text">
                                          Mã xác thực đăng nhập của tài khoản{" "}
                                          <b>{UserName}</b> với địa chỉ IP {IP}{" "}
                                          :{" "}
                                          <b
                                            style={{
                                              color: "#c0392b",
                                              fontSize: "16px",
                                            }}
                                          >
                                            {Code}
                                          </b>
                                        </p>
                                      </td>
                                      <td>
                                        <a
                                          onClick={() => {
                                            if (
                                              window.confirm(
                                                "Bạn muốn lưu địa chỉ IP?",
                                              )
                                            ) {
                                              LuuDiaChiIp(Code);
                                            }
                                          }}
                                        >
                                          <i className="fas fa-save"></i>
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          onClick={() => {
                                            if (
                                              window.confirm(
                                                "Bạn muốn xóa mã xác thực đã chọn?",
                                              )
                                            ) {
                                              XoaThongBaoDuyetIp(ID);
                                            }
                                          }}
                                        >
                                          <i className="fas fa-trash"></i>
                                        </a>
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            );
                          })}

                        <div class="ps-scrollbar-x-rail">
                          <div class="ps-scrollbar-x" tabindex="0"></div>
                        </div>
                        <div class="ps-scrollbar-y-rail">
                          <div class="ps-scrollbar-y" tabindex="0"></div>
                        </div>
                      </li>
                    </ul>
                  </li>
                </>
              )}
              <li className="dropdown dropdown-notification nav-item drop-question">
                <a
                  className="nav-link nav-link-label"
                  href={"/ticket/danhsach.aspx"}
                  style={{ marginTop: "5px" }}
                >
                  <i class="fas fa-question-circle"></i>
                </a>
              </li>
              <li className="dropdown dropdown-notification nav-item drop-question">
                <a
                  className="nav-link nav-link-label"
                  href={"/"}
                  data-toggle="dropdown"
                >
                  <img
                    className="hidden-mobile-main"
                    src="/app-assets/images/question.png"
                    alt=""
                  />
                  <img
                    className="d-md-none"
                    src="/app-assets/images/question-mobile.png"
                    alt=""
                  />
                </a>
                <ul className="dropdown-menu dropdown-menu-media dropdown-menu-right">
                  <li className="scrollable-container media-list w-100">
                    <a href="https://ultraviewer.net/vi/UltraViewer_setup_6.2_vi.exe">
                      <div className="media">
                        <div className="media-body">
                          <i className="fas fa-download"></i>
                          <h6 className="media-heading darken-1">
                            Download Ultraview
                          </h6>
                        </div>
                      </div>
                    </a>

                    <a href="https://download.teamviewer.com/full">
                      <div className="media">
                        <div className="media-body">
                          <i className="fas fa-download"></i>
                          <h6 className="media-heading darken-1">
                            Download Teamview
                          </h6>
                        </div>
                      </div>
                    </a>

                    <a
                      href="http://morman.vn/tong-quan-phan-mem-quan-ly-cam-do-morman"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <div className="media">
                        <div className="media-body">
                          &nbsp;&nbsp;<i className="fas fa-info"></i>&nbsp;{" "}
                          <h6 className="media-heading darken-1">
                            Xem hướng dẫn
                          </h6>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </li>

              <li className="dropdown dropdown-user nav-item">
                <a
                  className="dropdown-toggle nav-link dropdown-user-link"
                  href={"/"}
                  data-toggle="dropdown"
                >
                  <span className="avatar avatar-online">
                    <img
                      src={
                        Image
                          ? Image
                          : "/app-assets/images/portrait/small/avatar-s-19.png"
                      }
                      alt="avatar"
                    />
                  </span>
                  <span className="user-name-home">
                    {FullName} <i className="la la-angle-down"></i>
                  </span>
                </a>
                <div className="dropdown-menu dropdown-menu-right">
                  <a className="dropdown-item" href={"/"}>
                    <b>{FullName}</b>
                    <br />({UserName})
                  </a>
                  {/* <a
                    className="dropdown-item"
                    href={
                      configs.mormanServer +
                      "/trang-chu/thong-tin-dang-nhap.aspx"
                    }
                  >
                    <i className="ft-user"></i>
                    Thông tin tài khoản
                  </a> */}
                  <a
                    className="dropdown-item"
                    href={
                      configs.mormanServer +
                      "trang-chu/thong-tin-dang-nhap.aspx"
                    }
                  >
                    <i className="ft-user"></i>
                    Thông tin đăng nhập
                  </a>
                  <a
                    className="dropdown-item"
                    href={configs.mormanServer + "trang-chu/doi-mat-khau.aspx"}
                  >
                    <i className="la la-key"></i>
                    Đổi mật khẩu
                  </a>

                  <div className="dropdown-divider"></div>
                  <a
                    className="dropdown-item"
                    onClick={() => {
                      LogOut();
                    }}
                  >
                    <i className="ft-power"></i>
                    Đăng xuất
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {isShowModelThongBao && (
        <></>
        // <ModalThongBaoKhiDangNhap
        //   show={isShowModelThongBao}
        //   onHide={toggleModal}
        // />
      )}
      {iCountDataNew > 0 && (
        <ModalThongBaoDangKyVayMoi
          show={true}
          iCountDataNew={iCountDataNew}
          onHide={toggleModalData}
        />
      )}
      {showThongBaoHanSuDung && (
        <ModalThongbaoHanSuDung
          show={showThongBaoHanSuDung}
          hideThongBaoHanSuDung={hideThongBaoHanSuDung}
          value={valueHanSuDung}
        ></ModalThongbaoHanSuDung>
      )}

      {isThongBaoApp && (
        <ModalThongBaoApp
          show={isThongBaoApp}
          nameapp={nameThongBaoApp}
          setIsThongBaoApp={setIsThongBaoApp}
        ></ModalThongBaoApp>
      )}
    </nav>
  );
};

Header.propTypes = {
  showBackground: PropTypes.bool,
};

export default Header;
